import { generateUUID } from 'shared/helpers/utils/generate-uuid';
import { TableFilterFieldType } from 'common/TableFilter';
import {
  educationIncludeSaturdayOptions,
  educationParallels,
  educationShifts,
} from 'entities/education-class';
import type { TableFilterField } from 'common/TableFilter';

export const educationClassesFilterFields: TableFilterField[] = [
  {
    key: generateUUID(),
    name: 'parallel',
    label: 'Параллель',
    type: TableFilterFieldType.SELECT,
    options: educationParallels,
  },
  {
    key: generateUUID(),
    name: 'litera',
    label: 'Литера',
    type: TableFilterFieldType.INPUT,
    placeholder: 'Введите Литеру',
  },
  {
    key: generateUUID(),
    name: 'shift',
    label: 'Смена',
    type: TableFilterFieldType.SELECT,
    options: educationShifts,
  },
  {
    key: generateUUID(),
    name: 'includeSaturday',
    label: 'Класс учится в субботу',
    type: TableFilterFieldType.SELECT,
    options: educationIncludeSaturdayOptions,
  },
];
